import React from 'react';
import { View } from 'react-native';
import { fmt, useAppStore } from '@restorant/core';
import { useT } from '../i18n';
import { Screen } from '../components/Screen';
import { EmptyNote } from '../components/EmptyNote';
import { OrderRow } from '../components/OrderRow';
import { Panel } from '../components/Panel';
import { SectionTitle } from '../components/SectionTitle';
import { StatTile } from '../components/StatTile';

/** Full history of everything placed this session. Tap a row for the receipt. */
export function OrdersScreen({ contentPadding }: { contentPadding: number }) {
  const t = useT();
  const orders = useAppStore((s) => s.orders);
  const openOrderDetail = useAppStore((s) => s.openOrderDetail);

  const revenue = orders.reduce((s, o) => s + o.total, 0);
  const units = orders.reduce((s, o) => s + o.qty, 0);

  return (
    <Screen contentPadding={contentPadding}>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 14 }}>
        <StatTile value={String(orders.length)} label={t('stat_orders')} icon="order" />
        <StatTile value={String(units)} label={t('items_label')} icon="menu" />
        <StatTile value={fmt(revenue)} label={t('stat_revenue')} icon="rupee" />
      </View>

      <SectionTitle title={t('title_orders')} icon="clock" />
      {orders.length ? (
        <View>
          {[...orders].reverse().map((o) => (
            <OrderRow key={o.id} order={o} onPress={() => openOrderDetail(o.id)} />
          ))}
        </View>
      ) : (
        <Panel>
          <EmptyNote>{t('no_history')}</EmptyNote>
        </Panel>
      )}
    </Screen>
  );
}
